import * as action from 'actions'
import {call, put} from 'redux-saga/effects'
import * as actNotif from 'actions/notifications'
import * as api from 'api/get-filtered-date'
import moment from 'moment'

export function * getFilteredDate (query) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(api.getFilteredDate, query)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

/**
 * @param query
 * @return {{startDate: (Moment), endDate: (Moment)} | boolean}
 */
export function * getFilteredDateAsMoment (query) {
  let data = yield call(getFilteredDate, query)
  if (!data) {
    return false
  } else {
    let startDate = moment(data.start_date, 'YYYY-MM-DD')
    let endDate = moment(data.end_date, 'YYYY-MM-DD')
    return {startDate, endDate}
  }
}



// WEBPACK FOOTER //
// ./app/sagas/api/get-filtered-date.js